module.exports = __webpack_public_path__ + "img/dangerous.6453336f.png";